import { PgaPolicyDetail } from "src/shared/models/policy-detail.model";

export class HealthPolicyDetail extends PgaPolicyDetail {}
